import { HelmetData } from 'react-helmet-async'

export const helmetData = new HelmetData({})
